<template>
  <Select v-model="selected"
          :placeholder="placeholder"
          :remote-method="getDepartments"
          :loading="loading"
          :disabled="disabled"
          @on-change="handleValueChanged"
          remote
          filterable
          :clearable="clearable">
    <Option v-for="d in departmentsList" :key="d.id" :label="d.name" :value="d.id"></Option>
  </Select>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'DepartmentSelect',
  props: {
    placeholder: {
      type: String
    },
    clearable: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selected: this.$attrs.value,
      loading: false
    }
  },
  computed: mapGetters(['departmentsList']),
  mounted () {
    this.loadDepartments()
  },
  methods: {
    ...mapActions(['getDepartments']),
    loadDepartments () {
      this.loading = true
      this.getDepartments()
        .finally(() => {
          this.loading = false
        })
    },
    handleValueChanged (value) {
      const result = _.find(this.results, { id: value })
      this.$emit('input', value)
      this.$emit('update:department', result)
    }
  },
  watch: {
    '$attrs.value' (val) {
      this.selected = val
    }
  }
}
</script>
